import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

export const StyledTypography = styled(({ customVariant, ...rest }) => (
	<Typography {...rest} />
))(({ theme, customVariant }) => ({
	...(theme.typography[customVariant] || {}),
	fontSize: theme.typography[customVariant]?.fontSize,
	fontWeight: theme.typography[customVariant]?.fontWeight,
	lineHeight: theme.typography[customVariant]?.lineHeight,
	letterSpacing: theme.typography[customVariant]?.letterSpacing,
	color: theme.typography[customVariant]?.color,
	display: 'flex',
	alignItems: 'center',
	'& a, & a:hover, & a:focus, & a:active': {
		color: theme.palette.primary.main,
		textDecoration: 'underline',
		fontWeight: 'bold',
		cursor: 'pointer'
	}
}))

export const PrefixContainer = styled('span')(({ theme }) => ({
	display: 'inline-flex',
	alignItems: 'center',
	marginRight: '0.5rem',
	paddingBottom: '0.3125rem',
	color: theme.palette.primary.main
}))
